module.exports = __webpack_public_path__ + "static/media/upload.9ed4ad1c.svg";